import React from 'react';
import styled from 'styled-components';
import ReactSwiper from './vendor/ReactSwiper';
import ChevronLeft from '../../../svgs/ChevronLeft';
import ChevronRight from '../../../svgs/ChevronRight';
import { DOM_CAROUSEL, MOCK_ANALYTICS_PAGE_INTERACTION } from '../../../../lib/constants';
import Button from '../Button/Button';

const CarouselContainerDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  
  @media (max-width: ${(p) => p.theme.breakpoints.l[1]}px) {
    margin-left: ${(p) => p.theme.unit(5)};
    margin-right: ${(p) => p.theme.unit(5)};
  }
`;

const CarouselNavigationButton = styled(Button)`
  position: absolute;
  z-index: ${({ theme }) => theme.elevation[0]};
  margin-top: ${(p) => p.theme.unit(3)};
  
  ${(p) => (p.left ? `
  left: -32px;
  right: auto;
  ` : '')}
  
  ${(p) => (p.right ? `
  right: -32px;
  left: auto;
  ` : '')}

  &.swiper-button-disabled {
    display: none;
  }
`;

const CarouselContainerPaddingDiv = styled.div`
  width: 100%;
`;

class AMSSwiper extends React.Component {
  constructor(props) {
    super(props);
    this.swiper = null;
  }

  render() {
    const {
      slidesPerView,
      slidesPerGroup,
      breakpoints,
      navigationKey,
      spaceBetween,
    } = this.props;

    const prevButtonClassName = `swiper-button-prev${navigationKey ? `-${navigationKey}` : ''}`;
    const nextButtonClassName = `swiper-button-next${navigationKey ? `-${navigationKey}` : ''}`;

    const breakpointsToUse = breakpoints || {
      1000: {
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      1300: {
        slidesPerView: 4,
        slidesPerGroup: 4,
      },
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
      },
    };

    const params = {
      pagination: '.swiper-pagination',
      paginationType: 'fraction',
      spaceBetween: spaceBetween || 20,
      slidesPerView: slidesPerView || 5,
      slidesPerGroup: slidesPerGroup || 5,
      runCallbacksOnInit: true,
      grabCursor: true,
      loop: false,
      breakpoints: breakpointsToUse,
      prevButton: `.${prevButtonClassName}`,
      nextButton: `.${nextButtonClassName}`,
    };

    const mockTrackLeft = {
      dataTrackingId: `${DOM_CAROUSEL}_left_chevron`,
      dataTrack: MOCK_ANALYTICS_PAGE_INTERACTION,
    };

    const mockTrackRight = {
      dataTrackingId: `${DOM_CAROUSEL}_right_chevron`,
      dataTrack: MOCK_ANALYTICS_PAGE_INTERACTION,
    };

    const children = this.props && this.props.children ? this.props.children : [];

    const CarouselBody = children.length ? (
      <CarouselContainerDiv className="ams-swiper__container">
        <CarouselNavigationButton
          variant="primary"
          size="large"
          className={prevButtonClassName}
          data-track-id={mockTrackLeft.dataTrackingId}
          data-track-click={mockTrackLeft.dataTrack}
          renderLeftIcon={({ className }) => <ChevronLeft className={className} />}
          left
        />

        <CarouselContainerPaddingDiv>
          <ReactSwiper {...params}>
            { children }
          </ReactSwiper>
        </CarouselContainerPaddingDiv>

        <CarouselNavigationButton
          variant="primary"
          size="large"
          className={nextButtonClassName}
          data-track-id={mockTrackRight.dataTrackingId}
          data-track-click={mockTrackRight.dataTrack}
          renderLeftIcon={({ className }) => <ChevronRight className={className} />}
          right
        />
      </CarouselContainerDiv>
    ) : null;

    return CarouselBody;
  }
}

export default AMSSwiper;
